import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "new-receiver-view app-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "mb-4",
  "data-test": "add-new-receiver-heading"
}, "Setup a New Receiver", -1)
const _hoisted_3 = {
  key: 0,
  class: "dt-container mb-4"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_NewReceiverPairing = _resolveComponent("NewReceiverPairing")!
  const _component_NewReceiverType = _resolveComponent("NewReceiverType")!
  const _component_NewReceiverFinalPairing = _resolveComponent("NewReceiverFinalPairing")!
  const _component_NewReceiverRoom = _resolveComponent("NewReceiverRoom")!
  const _component_NewReceiverSuccess = _resolveComponent("NewReceiverSuccess")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.step===4 && !_ctx.canActivateReceivers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_TierLimit, {
            isCallout: true,
            message: _ctx.tierLimitReachedMessage
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["dt-container--large text-center", { 'onboarding__above-overlay' :  _ctx.userOnboardStatus.value.isOnboarding && _ctx.userOnboardStatus.value.showDialog && _ctx.currentStep.value.banner }])
    }, [
      (_ctx.step===1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_NewReceiverPairing, { onPairing: _ctx.onPair }, null, 8, ["onPairing"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step===2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_NewReceiverType, {
              newReceiverModel: _ctx.newReceiverModel,
              onReceiverType: _ctx.onReceiverType,
              legacyReceiversEnabled: _ctx.legacyReceiversEnabled
            }, null, 8, ["newReceiverModel", "onReceiverType", "legacyReceiversEnabled"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step===3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_NewReceiverFinalPairing, {
              newReceiverModel: _ctx.newReceiverModel,
              onFinalPairing: _ctx.onFinalPairing
            }, null, 8, ["newReceiverModel", "onFinalPairing"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step===4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_NewReceiverRoom, {
              newReceiverModel: _ctx.newReceiverModel,
              availableRooms: _ctx.availableRooms,
              onLinkRoom: _ctx.onRoomLink
            }, null, 8, ["newReceiverModel", "availableRooms", "onLinkRoom"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step===5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_NewReceiverSuccess, { onRestart: _ctx.onRestart }, null, 8, ["onRestart"])
          ]))
        : _createCommentVNode("", true)
    ], 2)), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierDialog,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showTierDialog) = $event)),
      isCallout: false,
      isLimit: true,
      message: _ctx.tierLimitReachedMessage
    }, null, 8, ["modelValue", "message"])
  ]))
}